<template>
    <div>
      <div class="row">
        <div class="col-sm-12">
          <div class="page-title-box">
            <div class="float-right mt-2">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                <li class="breadcrumb-item active">Dashboard</li>
              </ol>
            </div>
            <h4 class="page-title">Selamat Datang Di E-Retribusi</h4>
          </div>
        </div>
      </div>

      <div class="row">
        <!-- <div class="col-lg-4">
          <ItemReport 
          name="Total Instansi" :total="totalCompany" 
          icon="dripicons-wallet" color="text-pink"/>
        </div> -->

        <!-- <div class="col-lg-4">
          <ItemReport 
          name="Transaksi" :total="currency(totalTransaction)" 
          icon="dripicons-cart" color="text-secondary"/>
        </div> -->
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <h4 class="mt-0 mb-3 header-title">Transaksi Terakhir</h4>
              <div class="row">
                <div class="col-sm-12">
                  <div class="table-responsive">
                    <table class="table table-hover mb-0">
                      <thead class="thead-light">
                        <tr>
                          <th>Invoice Code</th>
                          <th>Kategori Retribusi</th>
                          <th>Instansi</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in transactions" :key="item.id">
                          <td>{{item.invoice_code}}</td>
                          <td>
                            <span v-for="(service, index) in item.service_name" :key="service+index">
                                {{service}}
                                <template v-if="index != item.service_name.length - 1">, </template>
                            </span>
                          </td>
                          <td>{{item.company.name}}</td>
                          <td>{{ currency(item.total) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import ItemReport from '@/components/dashboard/ItemReport'

import ApexCharts from 'apexcharts'
export default {
  data(){
    return {
      totalCompany: 0,
      totalTransaction: 0,
      transactions: [],
    }
  },
  components: {
    ItemReport
  },
  async mounted() {
    // GET SERVICE
    const dashboard = await this.$http.get(`${this.API_URL}dashboard?type=group`, {
        headers: { 
            'Authorization': `Bearer ${this.$cookies.get("token_group")}`
        }
    })

    // GET TRANSACTION
    const transaction = await this.$http.get(`${this.API_URL}transaction`, {
        headers: { 'Authorization': `Bearer ${this.$cookies.get("token_group")}` }
    })

    this.totalCompany = dashboard.data.company
    this.totalTransaction = dashboard.data.transaction
    this.transactions = transaction.data.data.slice(0, 5);
  },
}
</script>

<style>

</style>